import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Layout from '../components/layout';
import SEO from '../components/seo';

const Hero = styled.div`
  padding: 100px;
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <SEO title="Discover Workast" />
    <Hero>
      <h1>
        Index Page
      </h1>
    </Hero>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
};

export default IndexPage;
